import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	page: 1,
	selectedApi: null,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	loadingDetails: false,
	modelApiLoading: false,
};

const apiSlice = createSlice({
	name: "logManagement/api", // Descriptive name
	initialState,
	reducers: {
		setApiLoading: (state, action) => {
			state.loading = action.payload;
		},
		setApiData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;
			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
			state.loading = false;
		},
		setModelsTransactionsApiLoading: (state, action) => {
			state.modelApiLoading = action.payload;
		},
		setModelsTransactionsApiData: (state, action) => {
			const { models, transactions } = action.payload;
			state.models = models || [];
			state.transactions = transactions || [];
			state.modelApiLoading = false;
		},
		setSelectedApi: (state, action) => {
			state.selectedApi = action.payload;
		},
		setDetailsLoading: (state, action) => {
			state.loadingDetails = action.payload;
		},
	},
});

export const {
	setApiLoading,
	setApiData,
	setModelsTransactionsApiLoading,
	setModelsTransactionsApiData,
	setSelectedApi,
	setDetailsLoading,
} = apiSlice.actions;
export default apiSlice.reducer;
